module.exports = __webpack_public_path__ + "static/media/ic-completed-current.2fedae59.svg";